export default "__VITE_ASSET__BMjaHaOo__"